$( document ).ready( function () {

	let officesListArray = [...document.querySelectorAll( '.offices-list--item' )];

	const sections = [...document.querySelectorAll( '.section--observer' )];

	let slideNum = 0;

	let mapSection = document.querySelector('.section--map');
	let countryPathWrapper = document.querySelector('.country-paths');

	let officesBlock = document.querySelector('.offices-list');
	let windowHeight = window.innerHeight;
	let officesBlockHeight = officesBlock.offsetHeight;
	mapSection.style.height = windowHeight + officesBlockHeight + 'px';

	// added class active for map list
	function activeForAttribute( i ) {

		let allCheckedElements = document.querySelectorAll( '.check-element' );
		//remove all active classes
		allCheckedElements.forEach( ( element ) => {
			if ( element.classList.contains( 'active' ) ) {
				element.classList.remove( 'active' );
			}
		} )

		//list of current elements
		let listOfAttribut = document.querySelectorAll( `[data-number="${i}"]` );

		//added class active for current element
		listOfAttribut.forEach( ( element ) => {
			if ( !element.classList.contains( 'active' ) ) {
				element.classList.add( 'active' );

				if (element.classList.contains( 'country-map-path' ) ) {
					let activePath = element;
					$(element).remove();
					countryPathWrapper.insertAdjacentElement('beforeend', activePath);
				}
			}
		} )
	}

	//set top position for map section
	function setTopPositionForMapSection( currentSection ) {
		//$('body').css('overflow', 'hidden');
		//$( currentSection ).addClass( 'position' );

	}

	//unset top position for map section
	function unsetPosition( currentSection ) {
		//$('body').css('overflow', 'visible');
		//$( currentSection ).removeClass( 'position' );
	}


	$( '.section--map' ).on( 'click', function ( e ) {
		//setTopPositionForMapSection(this);
		sections.forEach( section => {
			observer.unobserve( section );
		} )
		// click on the icon on the map
		if ( e.target.tagName == 'path' && e.target.closest( '.mark' ) ) {
			let currentElement = e.target.closest( '.mark' );
			let currentElementIndex = $( currentElement ).data( 'number' );
			slideNum = currentElementIndex;

			//function - delete active and add active for current index
			activeForAttribute( currentElementIndex );
		}

		// click on the list
		if ( e.target.tagName == 'li' || e.target.closest( '.offices-list--item' ) ) {

			let currentElement = e.target.closest( '.offices-list--item' );
			let currentElementIndex = $( currentElement ).data( 'number' );
			slideNum = currentElementIndex;

			//function - delete active and add active for current index
			activeForAttribute( currentElementIndex );
		}
	} )

	let parentList = document.querySelector('.offices-list');

	//mouse scroll event
	function mouseScrollEvent(e) {

		if ( e.originalEvent.deltaY < 0 ) {
			if ( slideNum > 0 ) {

				--slideNum;

				//function - delete active and add active for current index
				activeForAttribute( slideNum );
			}
		}
		if ( e.originalEvent.deltaY > 0 ) {

			if ( slideNum < officesListArray.length - 1 ) {

				++ slideNum;

				//function - delete active and add active for current index
				activeForAttribute( slideNum );

			}
		}
	}

	//throttle function from internet
	function throttle(f, t) {
		return function (args) {
			let previousCall = this.lastCall;
			this.lastCall = Date.now();
			if (previousCall === undefined // function is being called for the first time
			    || (this.lastCall - previousCall) > t) { // throttle time has elapsed
				f(args);
			}
		}
	}

	//scroll with throttling
	$( '.section--map' ).bind("mousewheel", throttle(mouseScrollEvent, 80));

	//intersectionObserver

	const options = {
		root: null,
		threshold: 0.35,
		rootMargin: '-10% 0px -10% 0px'
	}

	const observer = new IntersectionObserver( function ( entries, observer ) {
		entries.forEach( entry => {

			if ( entry.isIntersecting ) {
				let scrollTop = $( entry.target ).position();
				let position = scrollTop.top - 60;
			}
		} );
	}, options );


	//remove observer for up-button click
	$( '.up-btn' ).on( 'click', ( e ) => {
		sections.forEach( section => {
			observer.unobserve( section );
		} )
	} )
	$( window ).on( 'scroll', () => {
		if ( window.pageYOffset <= 20 ) {
			sections.forEach( section => {
				observer.observe( section );
			} )
		}
	} )
} );
